import Decision from 'slotworks/state-machine/decisions/decision';
import { Exit } from 'slotworks/state-machine/data/exit';
import gameState from 'slotworks/model/game-state';
import { BuyoutTypes } from 'components/bonus-buy/bonus-buy-container';
import BuyoutRecord from 'integration/revolver/schema/buyout-record';

export default class IsBuyBonusCheck extends Decision {
    public evaluate() {
        const record = gameState.getCurrentGame().getCurrentRecord() as BuyoutRecord;

        if (record && record.type && record.type != BuyoutTypes.FREESPIN) {
            return Exit.True;
        }

        return Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/decisions/is-buy-bonus-check.ts